import { CampaignMediaEnum } from '@/campaign/main/model/CampaignApiTypes';

class MainSetting {
  public supportedMedias: Array<CampaignMediaEnum> = [];
  public showMallId: boolean = true;
  public showSenderPhoneNumber: boolean = true;
  public showPaymentManagement: boolean = true;
  public mustHaveKeywordToGetProductsAtContents: boolean = false;
  public showProductRepProductName: boolean = true;
  public showProductSellRecommendState: boolean = true;
  public enableCampaignMessageImageUpload: boolean = true;
  public showRepresentProductFilterForAudience: boolean = true;
  public showCreateDepartmentFilterForCampaignAndAudience: boolean = false;
  public showCreateDepartmentFilterForContentsAndImage: boolean = false;
  public showCreateDepartmentFilterForMessageTemplate: boolean = false;
  public showProductDetailFilter: boolean = true;
  public showDashboardCustomers: boolean = false;
  public showCustomerAnalysisAgent: boolean = process.env.REACT_APP_SHOW_CUSTOMER_ANALYSIS_AGENT === 'true';

  public showSetting: boolean = true;
  public showMediaManagement: boolean = true;
  public showDataConnection: boolean = true;
  public showBehaviorDataScript: boolean = true;
  public buyPlanUsingCredit: boolean = false;
  
  isSupportedMedia(media: CampaignMediaEnum): boolean {
    return this.supportedMedias!.includes(media);
  }
}

export default new MainSetting();
